// ---------------------------------------------------------------------------
// CodeBlock Renderer
// ---------------------------------------------------------------------------
// Engagement primitive — publishes the editor `CodeBlock` block as a
// semantic `<pre><code>` snippet with an optional language label. The
// code body is always text-escaped before insertion so user input cannot
// inject markup or break out of the surrounding tags. The label is
// rendered as plain text (escaped) — no client-side syntax highlighting
// is performed at publish time to keep the static HTML self-contained.

import { registerRenderer } from "../registry.js";
import type { RenderContext } from "../types.js";
import { attr, text } from "../escape.js";

interface CodeBlockProps {
  code?: string;
  language?: string;
}

function render(props: Record<string, unknown>, _ctx: RenderContext): string {
  const p = props as CodeBlockProps;

  const code = typeof p.code === "string" ? p.code : "";
  if (!code.trim()) {
    return "<!-- code-block missing code -->";
  }

  const language =
    typeof p.language === "string" ? p.language.trim() : "";

  const labelHtml = language
    ? `\n    <div class="ease-code-block__language" data-language="${attr(language)}">${text(language)}</div>`
    : "";

  return `<section class="ease-section ease-code-block">${labelHtml}
    <pre class="ease-code-block__pre"><code class="ease-code-block__code">${text(code)}</code></pre>
</section>`;
}

registerRenderer("code-block", { render });
